//export var config = { "environment": "development"};
export var config = { "environment": "production"};